




















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class AnimatedInput extends Vue {
    @Prop(String) label!: string;
    @Prop(String) hint!: string;
    @Prop(String) placeholder!: string;
    @Prop([String, Number]) value!: string | number;
    @Prop(Boolean) inline!: boolean;
    @Prop(String) error!: string;
    @Prop(String) type!: string;
    @Prop(Number) min!: number;
    @Prop(Boolean) autofocus!: boolean;
    @Prop(Boolean) required!: boolean;

    focused: boolean = false;
    internalValue: string | number = this.value || '';

    get animationClass() {
        if (this.focused || this.internalValue !== '') {
            return 'ai-filled';
        } else {
            return '';
        }
    }

    handleEnter() {
      this.$emit('enter');
    }

    handleInput() {
        this.$emit('input', this.internalValue);
    }

    handleFocus() {
        this.focused = true;
        this.$emit('focus');
    }

    handleBlur() {
        this.focused = false;
        this.$emit('blur');
    }

  checkAutofill(e: AnimationEvent) {
    if (e.animationName === "onAutoFillStart") {
      this.$emit("autofill", true);
    } else if (e.animationName === "onAutoFillCancel") {
      this.$emit("autofill", false);
    }
  }

  @Watch('value')
  onValueChanged(val: string, oldVal: string) {
    this.internalValue = val;
  }

    @Watch('internalValue')
    onInteralValueChanged(val: string, oldVal: string) { /* The decorator does a swap new -> internal */ }
}
